export type PasswordRule = {
  id: string;
  label: string;
  test: (senha: string) => boolean;
};

export const passwordRules: PasswordRule[] = [
  {
    id: 'tamanho',
    label: 'Mínimo 6 e máximo 20 caracteres',
    test: (s) => s.length >= 6 && s.length <= 20,
  },
  { id: 'maiuscula', label: 'Letra maiúscula', test: (s) => /[A-Z]/.test(s) },
  { id: 'minuscula', label: 'Letra minúscula', test: (s) => /[a-z]/.test(s) },
  {
    id: 'especial',
    label: 'Caractere especial',
    // eslint-disable-next-line no-useless-escape
    test: (s) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(s),
  },
  { id: 'numero', label: 'Número', test: (s) => /\d/.test(s) },
];

export const passwordIsValid = (senha: string): boolean =>
  passwordRules.every((rule) => rule.test(senha));
